import { Wrapper } from '@googlemaps/react-wrapper';
import PropTypes from 'prop-types';

/**
 * Component to load the Google Maps api with all of the libraries needed for the site.
 * This component accepts all of the same props as @googlemaps/react-wrapper Wrapper component
 */
const GoogleMapsLoader = ({ apiKey, children, waitForMaps, ...props }) => (
    <Wrapper
        {...props}
        apiKey={apiKey === 'STORYBOOK_GOOGLE_MAPS_API_KEY' ? '' : apiKey}
        id="GoogleMapsLoader"
        libraries={['places']}
        version="beta"
        render={waitForMaps ? undefined : () => <>{children}</>}
    >
        {children}
    </Wrapper>
);

GoogleMapsLoader.propTypes = {
    /**
     * Google Maps API key
     */
    apiKey: PropTypes.string,
    /**
     * Children to display
     */
    children: PropTypes.node,
    /**
     * When true, children only render after Google Maps has loaded.
     * Use this when children directly call window.google.maps APIs on mount.
     */
    waitForMaps: PropTypes.bool,
};

GoogleMapsLoader.defaultProps = {
    waitForMaps: false,
};

export default GoogleMapsLoader;
